<template>
  <div class="footer">
    <!-- 分为6列 -->
    <div class="footer-container w">
      <!-- 关于我们 -->
      <!-- <div class="aboutus" @click="goDetail('/about')">
        <div class="first-title">关于我们</div>
        <div class="sencond-title">
          <div class="item">公司介绍</div>
          <div class="item">商户合作</div>
        </div>
      </div> -->
      <!-- 智慧农贸 -->
      <div class="market aboutus">
        <div class="first-title" @click="goDetail('/')">智慧农贸</div>
        <div class="sencond-title">
          <div class="item" @click="goDetail('/')">应用平台</div>
          <div class="item" @click="goDetail('/device')">应用终端</div>
        </div>
      </div>
      <!-- 识别 -->
      <div class="ai aboutus" @click="goDetail('/AI')">
        <div class="first-title">AI识别</div>
      </div>
      <!-- 智慧新零售 -->
      <div class="success aboutus" @click="goDetail('/retail')">
        <div class="first-title">智慧新零售</div>
      </div>
      <!-- 帮助文档 -->
      <div class="doc aboutus" @click="goDetail('/doc')">
        <div class="first-title">帮助文档</div>
      </div>
      <!-- 成功案例 -->
      <!-- <div class="success aboutus" @click="goDetail('/case')">
        <div class="first-title">成功案例</div>
      </div> -->
      <!-- 公司 -->
      <div class="company aboutus" @click="goDetail('/about')">
        <div class="first-title">江苏城歌科技有限公司</div>
        <div class="sencond-title">
          <div class="item2">
            <i class="el-icon-document-checked"></i
            ><span>邮箱：support@cityode.com</span>
          </div>
          <div class="item2">
            <i
              class="el-icon-phone-outline
"
            ></i
            ><span>电话：{{ mobile }}</span>
          </div>
          <div class="item2">
            <i class="el-icon-location-information"></i>
            <span>地址：江苏省南京市鼓楼区南铁院金川科技园</span>
          </div>
        </div>
      </div>
      <!-- 二维码 -->
      <div class="qrcode aboutus">
        <div class="img">
          <img src="../assets/img/home/gongzhong.jpg" alt="" />
        </div>
        <!-- 文案 -->
        <div class="span">关注公众号了解更多</div>
      </div>
    </div>
    <!-- 备案号 -->
    <div class="put-on-records">
      <span
        >Copyright 2021 All rights reserved. Powered by 江苏城歌科技有限公司
        版权所有</span
      >
      <a @click="goWeb">{{ getIcp() }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      mobile: this.GLOBAL.mobile
    }
  },
  created() {},
  methods: {
    // 跳转
    goDetail(path) {
      this.$router.push(path)
      this.backTop()
    },
    // 回到顶部
    backTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    // 去外部
    goWeb() {
      window.open('http://beian.miit.gov.cn/', '_blank')
    },
    // 获取ICP备案号
    getIcp() {
      return '苏ICP备2026003348号'
    }
  }
}
</script>

<style lang="less" scoped>
.w {
  width: 1300px;
  margin: 0 auto;
}
.footer {
  height: 300px;
  background-color: #282828;
  color: #fff;
  padding-top: 80px;
  .footer-container {
    display: flex;
    margin: 0 auto;
    .aboutus {
      width: 200px;
      // text-align: center;
      .first-title {
        font-size: 24px;
        cursor: pointer;
      }
      .first-title:hover,
      .sencond-title .item:hover,
      .sencond-title .item2:hover {
        color: #009dff;
      }
      .sencond-title {
        margin-top: 40px;
        font-size: 16px;
        cursor: pointer;
        .item {
          margin: 20px 0;
        }
        .item2 {
          margin: 20px 0;
          text-align: start;
          span {
            margin-left: 10px;
          }
        }
      }
    }
    .company {
      width: 400px;
    }
    .qrcode {
      margin-left: 50px;
      img {
        width: 132px;
        height: 132px;
      }
      .span {
        font-size: 14px;
        margin-top: 22px;
        margin-left: 5px;
      }
    }
  }
}
.put-on-records {
  height: 100px;
  line-height: 150px;
  width: 800px;
  margin: 0 auto;
  a {
    margin-left: 20px;
    color: #fff;
    text-decoration: none;
  }
  a:hover {
    color: #009dff;
    cursor: pointer;
  }
}
</style>
